import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RoleSearchComponent } from './component/role-search.component';
import {HvlNgSharedModule, PrimengSharedModule} from "@hvlng/framework-core/shared";
import {UiSharedModule} from "ui-shared";
import {TranslateModule} from "@ngx-translate/core";



@NgModule({
  declarations: [
    RoleSearchComponent
  ],
    imports: [CommonModule, PrimengSharedModule, HvlNgSharedModule, UiSharedModule, TranslateModule],
    exports:[RoleSearchComponent]
})
export class RoleSearchModule { }
